export type LocationSource =
  'Entered' | 'MobileApp' | 'WebApp' | 'AppleEed' | 'Aml' | 'GoogleEls' | 'MobileAppSms';

type PortalLocationBase = {
  source: LocationSource;
  capturedAtUtc: string;
  receivedAtUtc: string;
};

export type PortalLocationKnown = PortalLocationBase & {
  type: 'Known';
  latitude: number;
  longitude: number;
};

export type PortalLocationMeasured = PortalLocationBase & {
  type: 'Measured';
  latitude: number;
  longitude: number;
  accuracy: number | null;
  altitude: number | null;
  altitudeAccuracy: number | null;
};

export type PortalLocationRedacted = PortalLocationBase & {
  type: 'Redacted';
  redactedAtUtc: string;
};

export type PortalLocation = PortalLocationKnown | PortalLocationMeasured | PortalLocationRedacted;
export type PortalCoordinateLocation = PortalLocationKnown | PortalLocationMeasured;

export function isCoordinateLocation(
  location: PortalLocation,
): location is PortalCoordinateLocation {
  return location.type === 'Known' || location.type === 'Measured';
}

export function isMeasuredLocation(location: PortalLocation): location is PortalLocationMeasured {
  return location.type === 'Measured';
}

export function normalizePortalLocation(location: PortalLocation): PortalLocation {
  if (location.type !== 'Measured') {
    return location;
  }

  return {
    ...location,
    accuracy: location.accuracy ?? null,
    altitude: location.altitude ?? null,
    altitudeAccuracy: location.altitudeAccuracy ?? null,
  };
}

type ExactlyTheUnion<TUnion extends string> = { [TMember in TUnion]: TMember };

export const LocationSource = {
  Entered: 'Entered',
  MobileApp: 'MobileApp',
  WebApp: 'WebApp',
  AppleEed: 'AppleEed',
  Aml: 'Aml',
  GoogleEls: 'GoogleEls',
  MobileAppSms: 'MobileAppSms',
} as const satisfies ExactlyTheUnion<LocationSource>;
